import {
  FaCloud,
  FaDatabase,
  FaExchangeAlt,
  FaServer,
  FaCode,
  FaCogs,
} from "react-icons/fa";

// Single source of truth for the technologies shown in TechnologySection
// and the /technology/:slug detail page.
export const technologies = [
  {
    slug: "salesforce",
    title: "Salesforce",
    Icon: FaCloud,
    description:
      "CRM implementation, customer experience optimization, and business process automation.",
    overview:
      "Salesforce is the world's leading customer relationship management (CRM) platform. We help organizations implement, customize, and optimize Salesforce to unify sales, service, and marketing — delivering a single, connected view of every customer.",
    features: [
      "Sales Cloud & Service Cloud implementation",
      "Custom objects, flows & Apex development",
      "Lightning experience & UI customization",
      "Third-party & legacy system integration",
      "Data migration, cleansing & governance",
      "Dashboards, reporting & analytics",
    ],
    useCases: [
      "360° customer view across departments",
      "Automating sales pipelines and approvals",
      "Case management and support workflows",
    ],
  },
  {
    slug: "mulesoft",
    title: "MuleSoft",
    Icon: FaExchangeAlt,
    description:
      "API-led connectivity and enterprise integration architecture.",
    overview:
      "MuleSoft's Anypoint Platform enables API-led connectivity, letting you unlock and connect data across any system, application, or device. We design reusable, secure integration architectures that accelerate delivery and reduce technical debt.",
    features: [
      "API-led connectivity architecture",
      "Anypoint Platform design & development",
      "Reusable system, process & experience APIs",
      "Real-time and batch data integration",
      "Security, throttling & API policies",
      "Monitoring, logging & error handling",
    ],
    useCases: [
      "Connecting SaaS, on-prem and legacy systems",
      "Building a reusable enterprise API layer",
      "Real-time data synchronization",
    ],
  },
  {
    slug: "boomi",
    title: "Boomi",
    Icon: FaServer,
    description:
      "Cloud integration, workflow automation, and application connectivity.",
    overview:
      "Boomi is a low-code integration platform-as-a-service (iPaaS) for connecting applications and automating workflows in the cloud. We use Boomi to rapidly build and manage integrations that keep your business systems in sync.",
    features: [
      "Cloud-native integration (iPaaS)",
      "Low-code process & data flow design",
      "Application-to-application connectivity",
      "Master data management (MDM)",
      "EDI & B2B integration",
      "Workflow automation & orchestration",
    ],
    useCases: [
      "Rapid SaaS-to-SaaS integrations",
      "Automating cross-system business processes",
      "Centralized, trusted master data",
    ],
  },
  {
    slug: "oracle-fusion",
    title: "Oracle Fusion",
    Icon: FaDatabase,
    description:
      "ERP, Finance, Procurement, and HR transformation solutions.",
    overview:
      "Oracle Fusion Cloud Applications provide a complete suite for ERP, finance, procurement, and HR. We support end-to-end transformation — from implementation and configuration to integration and adoption — to modernize your core business operations.",
    features: [
      "ERP & Financials implementation",
      "Procurement & supply chain modules",
      "HCM (Human Capital Management)",
      "Reporting, BI & analytics",
      "Integration with enterprise systems",
      "Configuration, testing & rollout",
    ],
    useCases: [
      "Modernizing finance and back-office operations",
      "Unified procurement and spend management",
      "Streamlined HR and payroll processes",
    ],
  },
  {
    slug: "api-management",
    title: "API Management",
    Icon: FaCode,
    description:
      "Secure, scalable, and modern API lifecycle management.",
    overview:
      "APIs are the backbone of modern digital businesses. We provide full API lifecycle management — design, security, publishing, versioning, and analytics — so your APIs are safe, discoverable, and easy for partners and developers to consume.",
    features: [
      "API design & specification (OpenAPI)",
      "Gateway setup, security & OAuth",
      "Rate limiting, throttling & quotas",
      "Developer portals & documentation",
      "Versioning & lifecycle governance",
      "Usage analytics & monitoring",
    ],
    useCases: [
      "Exposing services securely to partners",
      "Monetizing and governing public APIs",
      "Standardizing internal API delivery",
    ],
  },
  {
    slug: "cloud-integration",
    title: "Cloud Integration",
    Icon: FaCogs,
    description:
      "Connecting applications, platforms, and business systems.",
    overview:
      "Cloud integration connects your applications, data, and processes across cloud and on-premise environments. We build resilient, scalable integration solutions that eliminate silos and enable seamless, real-time information flow across your organization.",
    features: [
      "Hybrid cloud & on-prem connectivity",
      "Event-driven & real-time integration",
      "Data pipelines & transformation",
      "Scalable, fault-tolerant architecture",
      "Security & compliance by design",
      "Monitoring & operational visibility",
    ],
    useCases: [
      "Breaking down data and system silos",
      "Migrating and connecting cloud workloads",
      "Real-time cross-platform data flow",
    ],
  },
];

export const getTechnology = (slug) =>
  technologies.find((t) => t.slug === slug);
